module.exports = __webpack_public_path__ + "static/media/simpel.da8c3c4e.mp3";